var _path, _path2, _path3, _circle, _circle2, _path4, _circle3, _circle4, _path5, _circle5, _circle6, _path6, _circle7, _circle8, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 134,
    viewBox: "0 0 335 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M311 133.5V51.5001C301 51.5001 255.5 52 248 52C241.424 52 203.5 52.5001 193.5 55.0001C172 58.5 169 64 132.5 76.5C96 89 78.5 94.5 24 104.5V133.5H311Z",
    fill: "url(#paint0_linear_22_707)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5396 104.396C66.2733 97.0693 90.3601 90.9137 125.802 79.4317C155.445 69.8282 162.5 59 215 52H309.5",
    stroke: "url(#paint1_linear_22_707)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190 26.5C190 20.701 194.701 16 200.5 16H230.5C236.299 16 241 20.701 241 26.5C241 32.299 236.299 37 230.5 37H220L215 40L210 37H200.5C194.701 37 190 32.299 190 26.5Z",
    fill: "#0DD15B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 52,
    r: 4,
    fill: "#1CD774"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 52,
    r: 5.5,
    stroke: "#1CD774",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284 26.5C284 20.701 288.701 16 294.5 16H324.5C330.299 16 335 20.701 335 26.5C335 32.299 330.299 37 324.5 37H314L309 40L304 37H294.5C288.701 37 284 32.299 284 26.5Z",
    fill: "#0DD15B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 52,
    r: 4,
    fill: "#1CD774"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 52,
    r: 5.5,
    stroke: "#1CD774",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 78.5C0 72.701 4.70101 68 10.5 68H40.5C46.299 68 51 72.701 51 78.5C51 84.299 46.299 89 40.5 89H30L25 92L20 89H10.5C4.70101 89 0 84.299 0 78.5Z",
    fill: "#3E65EF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 104,
    r: 4,
    fill: "#3E65EF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 104,
    r: 5.5,
    stroke: "#3E65EF",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94 56.5C94 50.701 98.701 46 104.5 46H134.5C140.299 46 145 50.701 145 56.5C145 62.299 140.299 67 134.5 67H124L119 70L114 67H104.5C98.701 67 94 62.299 94 56.5Z",
    fill: "#3E65EF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 82,
    r: 4,
    fill: "#3E65EF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 82,
    r: 5.5,
    stroke: "#3E65EF",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 132V104",
    stroke: "#F6F8FA",
    strokeDasharray: "2 2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119 132V85",
    stroke: "#F6F8FA",
    strokeDasharray: "2 2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M215 132V59",
    stroke: "#F6F8FA",
    strokeDasharray: "2 2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M311 132V58",
    stroke: "#F6F8FA",
    strokeDasharray: "2 2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_707",
    x1: 167,
    y1: 35,
    x2: 167,
    y2: 142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E65EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F8FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22_707",
    x1: -38,
    y1: 116.5,
    x2: 309.939,
    y2: 51.6723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E95EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506574,
    stopColor: "#3E65EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688435,
    stopColor: "#BDFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738476,
    stopColor: "#56E64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CD774"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart2);
export default __webpack_public_path__ + "static/media/chart2.0bbf571123fadb2e472e227acea7839a.svg";
export { ForwardRef as ReactComponent };